var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag2Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.75V16.5H1.5V2.25H15.8535C15.9192 2.24989 15.9838 2.26706 16.0408 2.29979C16.0979 2.33252 16.1453 2.37966 16.1783 2.43648C16.2113 2.4933 16.2289 2.55781 16.2291 2.62355C16.2294 2.68928 16.2124 2.75392 16.1798 2.811L13.5 7.5L16.1798 12.189C16.2124 12.2461 16.2294 12.3107 16.2291 12.3765C16.2289 12.4422 16.2113 12.5067 16.1783 12.5635C16.1453 12.6203 16.0979 12.6675 16.0408 12.7002C15.9838 12.7329 15.9192 12.7501 15.8535 12.75H3ZM3 3.75V11.25H13.9155L11.772 7.5L13.9155 3.75H3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag2Line);
export default __webpack_public_path__ + "static/media/flag-2-line.ae44ca94cf55ac764ce5a8f854d76662.svg";
export { ForwardRef as ReactComponent };